/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Language in which the user sees content of application

Values: 0=CZ, 1=EN, 2=SK, 3=DE, 4=BG, 5=RO, 6=HU, 7=PL, 8=HR, 9=SL
 * @export
 * @enum {number}
 */

export enum LocalizationLanguage {
    CZ = 0,
    EN = 1,
    SK = 2,
    DE = 3,
    BG = 4,
    RO = 5,
    HU = 6,
    PL = 7,
    HR = 8,
    SL = 9
}


